import { GenericCellProps } from './type';
import Typography from '../../../Typography';

const GenericCell = ({ ...props }: GenericCellProps) => {
  const { fontSize, value, style, ...rest } = props;
  return (
    <Typography {...rest} fontSize={fontSize} style={style}>
      {value}
    </Typography>
  );
};
GenericCell.defaultProps = {
  fontSize: 12,
  value: '',
  style: {},
};

export default GenericCell;
